import { useQuery } from '@tanstack/react-query';
import { bookingReportsApi, BookingReportFilters, exportBookingsToCsv } from '../api/bookingReportsApi';

const QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: 60 * 1000,
} as const;

export const useBookingReport = (filters?: BookingReportFilters) =>
  useQuery({
    queryKey: ['booking-report', filters ?? {}],
    queryFn: () => bookingReportsApi.getReport(filters),
    ...QUERY_OPTIONS,
  });

const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
};

// The backend has no export endpoint; CSV is generated client-side from the loaded bookings.
export const useExportBookingReport = () => {
  const exportCsv = async (filters?: BookingReportFilters) => {
    const report = await bookingReportsApi.getReport(filters);
    downloadBlob(exportBookingsToCsv(report.bookings), 'booking-report.csv');
  };
  return { exportCsv };
};

